import { gql } from '@apollo/client'

import { fragments } from './fragments'

export default gql`
    query shipmentLines($id: String!, $limit: Int!, $cursor: ENCODED_CURSOR) {
        shipment(id: $id) {
            id
            shipmentLines(limit: $limit, cursor: $cursor) {
                totalCount
                cursor {
                    previous
                    next
                }
                items {
                    id
                    quantity
                    totalQuantity
                    processName
                    processNames
                    processes {
                        id
                        platformProcessId
                        processName
                        processNotes
                        color
                        thickness
                        texture
                        finish
                        toolLife
                        surfaceFinishCode
                        additionalSpecifications {
                            color
                            texture
                            thickness
                        }
                        dfmNotes {
                            color
                            process
                            texture
                            thickness
                        }
                    }
                    materialDetails {
                        id
                        name
                        color
                        shore
                        colorCode
                        materialGrade
                        publicName
                    }
                    woAvailableToShow
                    quoteModelRevisionAttachment {
                        id
                        fileName
                        downloadUrl
                        sanitized {
                            id
                            fileName
                            downloadUrl
                        }
                        annotated {
                            id
                            fileName
                            downloadUrl
                        }
                    }
                    boundingBox {
                        ...boundingBox
                    }
                    inspectionDocuments {
                        ...inspectionDocuments
                    }
                    revision {
                        ...revision
                    }
                    dfmFeedback {
                        ...dfmFeedbackOrderDetailsPage
                    }
                    holes {
                        ...holes
                    }
                    inspectionTypes
                    erpMoldId
                }
            }
        }
    }
    ${fragments.Revision}
    ${fragments.DfmFeedback}
    ${fragments.Holes}
    ${fragments.BoundingBox}
    ${fragments.InspectionDocuments}
`
